// extracted by mini-css-extract-plugin
module.exports = {"center":"center--1J4F-","extra":"extra--35U4y","resultTitle":"resultTitle--1mkvb"};